import { useContext } from "react";
import NavContext from "src/context/navContext";

const useNav = () => {
  const value = useContext(NavContext);
  return value;
};

export default useNav;
